export const GET_RESERVATIONS_API = "/reservations/reservations-since-yesterday/";

export const ADD_RESERVATION_API = "/reservations/";

export const DELETE_RESERVATION_API = "/reservations/";

export const UPDATE_RESERVATION_API = "/reservations/";

export const CONFIRM_RESERVATION_API = "/reservations/";

export const CANCEL_RESERVATION_API = "/reservations/";

export const MARK_AS_READ_RESERVATION_API = "/reservations/";


// WEBPACK FOOTER //
// ./src/apis/reservations.js